import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {  TestReportResponse, AssessmentStatusResponse, MatchReportRespone, TestStatusResponse, MindlerReportAnalysisRequest } from '../../models/psychometric-test/psychometric-test.model';
import { GenericService } from '../generic.service';
// import { TestType } from '../../models/enums/enums';
import { AssessmentType } from '../../models/enums/assessmentType';

@Injectable({
  providedIn: 'root',
})
export class PsychometricTestService {
  constructor(private genericService:GenericService)
  {

  }

  isTestTaken():Observable<TestStatusResponse>
  {
    return this.genericService.get(`mindler/test-status`)
  }

  getSummaryReport(studentid: string):Observable<TestReportResponse>
  {
    return this.genericService.get(`mindler/test-summary-report/${studentid}`);
  }

  getDetailReport(studentid: string):Observable<TestReportResponse>
  {
    return this.genericService.get(`mindler/test-detail-report/${studentid}`);
  }

  // assessmentType is optional: omit it for the student's active test (student portal),
  // pass it to get a specific test's match data (admin Mindler report).
  getMatchReport(studentid: string, assessmentType?: AssessmentType | null):Observable<MatchReportRespone>
  {
    const query = assessmentType ? `?assessmentType=${assessmentType}` : '';
    return this.genericService.get(`mindler/test-match-data/${studentid}${query}`);
  }

  getTestAssessmentStatus(): Observable<AssessmentStatusResponse> {
    return this.genericService.get(`mindler/assessment-status`);
  }

  startTest(): Observable<{ testUrl: string }> {
    return this.genericService.get(`mindler/take-test`);
  }

  createRequestReportAnalysis(studentId: string, reportAnalysisRequest: MindlerReportAnalysisRequest): Observable<void> {
    return this.genericService.post(`mindler/test/report-analysis-request/${studentId}`, reportAnalysisRequest);
  }
}

